
//import {Parser as HtmlToReactParser} from 'html-to-react';
import {Parser as HtmlToReactParser} from 'html-to-react';
const htmlToReactParser = new HtmlToReactParser();

export const getValueByKey = (self, key) => {
  if (self) {
    let findElement = null;
    let findElemnt2 = null;

    findElement = self.find((a) => a.key === key);
    if (!findElement) {
      findElemnt2 = self.find((a) => a.Key === key);
    }

    return findElement
      ? findElement.value
      : findElemnt2
      ? findElemnt2.Value
      : null;
  }
  return "";
};
export const getValueByKeyLp = (self, key) => {
  if(self){
    let findElement = null;
    let findElemnt2 = null;

    findElement = self.properties.find(a => a.key === key);
    if(!findElement){
      findElemnt2 = self.properties.find(a => a.Key === key);
    }

    return findElement ? findElement.value : (findElemnt2 ? findElemnt2.value : null);
  }
  return '';
  
};
export const getParsedHtmlValueByKey = (self, key) => {
  return htmlToReactParser.parse(getValueByKey(self, key));
};

export const getBreadCrumbsProperties = (self, key) => {
  if (self) {
    let findElement = null;

    findElement = self.Properties.find((a) => a.Key === key);

    return findElement ? findElement.Value : null;
  }
  return "";
};

export const getCheckbox = (self, key) => getValueByKey(self, key) === "True";

// export default { getValueByKey, getCheckbox };
